import { JSX, useEffect, useMemo, useState } from 'react'

import { IForm } from 'core-components/classes/models/IForm'
import { arrayToObject } from 'core-components/helpers/url'
import { ModalDialog } from 'core-components/library/modalDialog'
import { IKeyboardEvent, KeyboardContext } from 'core-components/wrappers/keyboard'
import { history } from 'src/core/classes/helpers/history'

import { IPendingDescription, URLContext } from './URLContext'
import { IQuestionProps, UrlControllerQuestion } from './UrlControllerQuestion'

interface IURLControllerProps {
  children: JSX.Element | JSX.Element[]
}
//TODO: https://hpheroes.atlassian.net/browse/ASKSPOC-2851
export const URLController = (props: IURLControllerProps) => {
  const [children] = useState<any[]>([])
  const [pendings] = useState<IPendingDescription[]>([])
  const [activeOperation, setActiveOperation] = useState<IPendingDescription | undefined>()
  const [destinationUrl, setDestinationUrl] = useState<IForm>({})
  const [checkPromise] = useState({ resolve: (value?: any) => {} })
  const [keyboardCtrl] = useState<any>({})
  let modalClose: () => void

  const keysObj = useMemo(() => {
    return [
      {
        key: 'Enter',
        ctrlKey: true,
        fn: () => {
          if (!activeOperation) {
            return false
          }
          activeOperation.buttons[0].callback().then((result) => {
            history.push(destinationUrl.path, destinationUrl.state)
            modalClose && modalClose()
            setActiveOperation(undefined)
            setDestinationUrl({})
            checkPromise.resolve(result)
            return result
          })
          return false
        },
      },
    ] as IKeyboardEvent[]
  }, [activeOperation, destinationUrl])

  useEffect(() => {
    if (keyboardCtrl.obj) {
      return keyboardCtrl.obj.unregistr
    }
  })

  useEffect(() => {
    const pushStateOriginal = history.push
    // @ts-ignore
    history.push = (path: string, state: IForm) => {
      const oldParams = arrayToObject(window.location.pathname.substring(1).split('/'))
      const newParams = arrayToObject(path ? path.substring(1).split('/') : [])
      for (const pending of pendings) {
        for (const parameter of pending.parameters) {
          if (oldParams[parameter] !== newParams[parameter]) {
            if (pending.ignoreParams && pending.ignoreParams[parameter] === oldParams[parameter]) {
              // @ts-ignore
              pushStateOriginal.call(history, path, state)
              return
            }
            setActiveOperation(pending)
            setDestinationUrl({ path, state })
            return
          }
        }
      }
      // @ts-ignore
      pushStateOriginal.call(history, path, state)
    }
    return () => {
      history.push = pushStateOriginal
    }
  }, [])

  const urlContextValue = {
    registr: () => {
      let temp: any = undefined
      const final = {
        addPendingFn: (operation: IPendingDescription) => {
          pendings.push(operation)
          temp = () => {
            const findIndex = pendings.findIndex((val) => val === operation)
            pendings.splice(findIndex, 1)
            temp = undefined
          }
          return temp
        },
        unregistr: () => {
          const findIndex = children.findIndex((val: any) => val === final)
          children.splice(findIndex, 1)
          if (temp) {
            temp()
          }
        },
      }
      children[children.length] = final
      return final
    },
    checkPendings: async () => {
      if (pendings.length) {
        setActiveOperation(pendings[0])
        const promise = new Promise<boolean>((resolve) => {
          checkPromise.resolve = resolve
        })
        return promise
      }
      return true
    },
  }

  return (
    <URLContext.Provider value={urlContextValue}>
      <>
        {props.children}
        {activeOperation ? (
          <KeyboardContext.Consumer>
            {({ registr }) => {
              keyboardCtrl['obj'] = registr(keysObj)
              return (
                <ModalDialog<IQuestionProps>
                  show
                  size={'sm'}
                  content={(dialogProps) => {
                    modalClose = () => dialogProps.closeModal()
                    return UrlControllerQuestion(dialogProps)
                  }}
                  contentProps={{
                    activeOperation,
                    onEndOperation: (value?: any) => {
                      setActiveOperation(undefined)
                      setDestinationUrl({})
                      checkPromise.resolve(value)
                    },
                    onChoose: () => {
                      if (destinationUrl.path && destinationUrl.state) {
                        history.push(destinationUrl.path, destinationUrl.state)
                      }
                    },
                  }}
                  onClose={() => setActiveOperation(undefined)}
                />
              )
            }}
          </KeyboardContext.Consumer>
        ) : null}
      </>
    </URLContext.Provider>
  )
}
